import {
  CurrencyCode,
  BillStatus,
  BillType,
  BillCategory,
  ApexApiBill,
} from "@hagerty/self-service-components";
import { Bill } from "@hagerty/self-service-components/api/types";

export type MockCoreBill = Bill & {
  label: string;
};

export type MockApexBill = ApexApiBill & {
  label: string;
};

export const hdcUpcomingBill: MockCoreBill = {
  label: "Upcoming HDC 1.5 Bill",
  currency: CurrencyCode.Usd,
  expirationDate: "",
  informAboutStatus: true,
  paymentUrl: "",
  status: BillStatus.Ok,
  total: {
    amount: 10000,
    formattedAmount: "$100",
  },
  type: BillType.PayOnce,
  productNumber: "1",
  category: BillCategory.Hdc1Dot5,
  id: "1",
  amount: 10000,
  formattedAmount: "$100",
  nextPaymentDate: "2021-05-01",
  productDetails: ["Membership"],
  revalOffer: null,
};

export const hdcPastDueBill: MockCoreBill = {
  ...hdcUpcomingBill,
  label: "Past Due HDC 1.5 Bill",
  status: BillStatus.PastDue,
  productNumber: "2",
  id: "2",
};

export const hdcAutopayBill: MockCoreBill = {
  label: "Autopay HDC 1.5 Bill",
  currency: CurrencyCode.Usd,
  expirationDate: "",
  informAboutStatus: true,
  paymentUrl: "",
  status: BillStatus.Ok,
  total: {
    amount: 10000,
    formattedAmount: "$100",
  },
  type: BillType.AutoPay,
  productNumber: "3",
  category: BillCategory.Hdc1Dot5,
  id: "3",
  amount: 10000,
  formattedAmount: "$100",
  nextPaymentDate: "2021-05-01",
  productDetails: ["Membership"],
  revalOffer: null,
};

export const hdcAutopayFailedBill: MockCoreBill = {
  ...hdcAutopayBill,
  label: "Autopay Failed HDC 1.5 Bill",
  status: BillStatus.Failed,
  productNumber: "4",
  id: "4",
};

export const autopayCoreBill: MockCoreBill = {
  label: "Autopay Core Bill",
  productNumber: "5",
  category: BillCategory.Insurance,
  id: "5",
  amount: 500000,
  formattedAmount: "$5,000",
  type: BillType.AutoPay,
  autoPayMethodDetails: {
    last4: "1234",
  },
  expirationDate: "",
  nextPaymentDate: "2099-01-01",
  currency: CurrencyCode.Usd,
  paymentUrl: "",
  informAboutStatus: true,
  status: BillStatus.Ok,
  total: {
    amount: 500000,
    formattedAmount: "$5,000",
  },
  productDetails: ["1956 Porsche Cayenne", "1944 Ford Model T"],
  revalOffer: null,
};

export const autopayFailedCoreBill: MockCoreBill = {
  ...autopayCoreBill,
  label: "Autopay Failed Core Bill",
  productNumber: "6",
  id: "6",
  status: BillStatus.Failed,
};

export const upcomingCoreBill: MockCoreBill = {
  label: "Upcoming Core Bill",
  productNumber: "7",
  category: BillCategory.Insurance,
  id: "7",
  amount: 70000,
  formattedAmount: "$700",
  type: BillType.PayOnce,
  expirationDate: "",
  nextPaymentDate: "2000-01-01",
  currency: CurrencyCode.Usd,
  paymentUrl: "",
  informAboutStatus: true,
  status: BillStatus.Ok,
  total: {
    amount: 70000,
    formattedAmount: "$700",
  },
  productDetails: ["1956 Porsche Cayenne", "1944 Ford Model T"],
  isSubmitted: false,
  revalOffer: null,
};

export const pastDueCoreBill: MockCoreBill = {
  ...upcomingCoreBill,
  label: "Past Due Core Bill",
  productNumber: "8",
  id: "8",
  status: BillStatus.PastDue,
};

export const upcomingCoreRevalBill: MockCoreBill = {
  label: "Upcoming Core Reval Bill",
  productNumber: "9",
  category: BillCategory.Insurance,
  id: "9",
  amount: 70000,
  formattedAmount: "$700",
  type: BillType.PayOnce,
  expirationDate: "",
  nextPaymentDate: "2000-01-01",
  currency: CurrencyCode.Usd,
  paymentUrl: "",
  informAboutStatus: true,
  status: BillStatus.Ok,
  total: {
    amount: 70000,
    formattedAmount: "$700",
  },
  productDetails: ["1956 Porsche Cayenne", "1944 Ford Model T"],
  isSubmitted: false,
  revalOffer: {
    // Check when test accounts will exist if currentPremium is formatted or not
    currentPremium: "700",
    endoNumber: "123123123",
    endoStatus: "UNKN",
    newPremium: "900",
    policyNumber: "id123",
    premiumDifference: "200",
    vehicleValues: [],
  },
};

export const pastDueCoreRevalBill: MockCoreBill = {
  ...upcomingCoreRevalBill,
  label: "Past Due Core Reval Bill",
  productNumber: "10",
  id: "10",
  status: BillStatus.PastDue,
};

export const upcomingCoreAlignedBill: MockCoreBill = {
  label: "Upcoming Core Aligned (1.0) Bill",
  productNumber: "11",
  category: BillCategory.Insurance,
  id: "11",
  amount: 50362,
  formattedAmount: "$503.62",
  type: BillType.PayOnce,
  expirationDate: "",
  nextPaymentDate: "2025-05-18T00:00:00",
  currency: CurrencyCode.Usd,
  paymentUrl: "",
  informAboutStatus: true,
  status: BillStatus.Ok,
  total: {
    amount: 57362,
    formattedAmount: "$573.62",
  },
  productDetails: ["1956 Porsche Cayenne", "1944 Ford Model T"],
  isSubmitted: false,
  revalOffer: null,
  alignedBill: {
    category: BillCategory.Hdc1Dot0,
    formattedAmount: "$70",
    productDetails: ["Drivers Club 1.0 membership"],
  },
};

export const pastDueCoreAlignedBill: MockCoreBill = {
  ...upcomingCoreAlignedBill,
  label: "Past Due Core Aligned (1.0) Bill",
  productNumber: "12",
  id: "12",
  status: BillStatus.PastDue,
};

export const autopayCoreAlignedBill: MockCoreBill = {
  label: "Autopay Core Aligned (1.0) Bill",
  productNumber: "13",
  category: BillCategory.Insurance,
  id: "13",
  amount: 50362,
  formattedAmount: "$503.62",
  type: BillType.AutoPay,
  autoPayMethodDetails: {
    last4: "1234",
  },
  expirationDate: "",
  nextPaymentDate: "2025-05-18T00:00:00",
  currency: CurrencyCode.Usd,
  paymentUrl: "",
  informAboutStatus: true,
  status: BillStatus.Ok,
  total: {
    amount: 57362,
    formattedAmount: "$573.62",
  },
  productDetails: ["1956 Porsche Cayenne", "1944 Ford Model T"],
  isSubmitted: false,
  revalOffer: null,
  alignedBill: {
    category: BillCategory.Hdc1Dot5,
    formattedAmount: "$70",
    productDetails: ["Membership"],
  },
};

export const autopayFailedCoreAlignedBill: MockCoreBill = {
  ...autopayCoreAlignedBill,
  label: "Autopay Failed Core Aligned (1.0) Bill",
  productNumber: "14",
  id: "14",
  status: BillStatus.Failed,
};

export const upcomingCoreAlignedOmniBill: MockCoreBill = {
  ...upcomingCoreAlignedBill,
  label: "Upcoming Core Aligned (1.5) Bill",
  productNumber: "15",
  id: "15",
  alignedBill: {
    category: BillCategory.Hdc1Dot5,
    formattedAmount: "$70",
    productDetails: ["Membership"],
  },
};

export const pastDueCoreAlignedOmniBill: MockCoreBill = {
  ...pastDueCoreAlignedBill,
  label: "Past Due Core Aligned (1.5) Bill",
  productNumber: "16",
  id: "16",
  alignedBill: {
    category: BillCategory.Hdc1Dot5,
    formattedAmount: "$70",
    productDetails: ["Membership"],
  },
};

export const autopayCoreAlignedOmniBill: MockCoreBill = {
  ...autopayCoreAlignedBill,
  label: "Autopay Core Aligned (1.5) Bill",
  productNumber: "17",
  id: "17",
  alignedBill: {
    category: BillCategory.Hdc1Dot5,
    formattedAmount: "$70",
    productDetails: ["Membership"],
  },
};

export const autopayFailedCoreAlignedOmniBill: MockCoreBill = {
  ...autopayFailedCoreAlignedBill,
  label: "Autopay Failed Core Aligned (1.5) Bill",
  productNumber: "18",
  id: "18",
  alignedBill: {
    category: BillCategory.Hdc1Dot5,
    formattedAmount: "$70",
    productDetails: ["Membership"],
  },
};

export const paidCoreBill: MockCoreBill = {
  label: "Paid Core Bill",
  productNumber: "19",
  category: BillCategory.Insurance,
  id: "19",
  amount: 1200000,
  formattedAmount: "$12,000",
  type: BillType.PayOnce,
  expirationDate: "2000-01-01",
  nextPaymentDate: "2000-01-01",
  currency: CurrencyCode.Usd,
  paymentUrl: "",
  informAboutStatus: true,
  status: BillStatus.Ok,
  total: {
    amount: 1200000,
    formattedAmount: "$12,000",
  },
  productDetails: ["1956 Porsche Cayenne", "1944 Ford Model T"],
  isSubmitted: true,
};

export const mockCoreBills: MockCoreBill[] = [
  hdcUpcomingBill,
  hdcPastDueBill,
  hdcAutopayBill,
  hdcAutopayFailedBill,
  upcomingCoreBill,
  pastDueCoreBill,
  autopayCoreBill,
  autopayFailedCoreBill,
  upcomingCoreRevalBill,
  pastDueCoreRevalBill,
  upcomingCoreAlignedBill,
  pastDueCoreAlignedBill,
  autopayCoreAlignedBill,
  autopayFailedCoreAlignedBill,
  upcomingCoreAlignedOmniBill,
  pastDueCoreAlignedOmniBill,
  autopayCoreAlignedOmniBill,
  autopayFailedCoreAlignedOmniBill,
  paidCoreBill,
];

export const apexAutopayBill: MockApexBill = {
  label: "Autopay Apex Bill",
  source: "apex",
  policyNumber: "en01",
  billStatus: "HAS_BILL",
  invoiceDueDate: "2099-01-01",
  invoiceDueAmount: 250,
  isAutoPay: true,
  paymentPlanPeriod: "ANNUAL",
  vehicles: ["1990 Chevrolet Impala"],
};

export const apexUpcomingBill: MockApexBill = {
  label: "Upcoming Apex Bill",
  source: "apex",
  policyNumber: "en01",
  billStatus: "HAS_BILL",
  invoiceDueDate: "2099-01-01",
  invoiceDueAmount: 500,
  isAutoPay: false,
  paymentPlanPeriod: "SEMIANNUAL",
  vehicles: ["1999 Chevrolet Impala"],
};

export const apexAutopayFailedBill: MockApexBill = {
  label: "Autopay Failed Apex Bill",
  source: "apex",
  policyNumber: "en01",
  billStatus: "FAILED",
  pastDueAmount: 750,
  isAutoPay: true,
  paymentPlanPeriod: "ANNUAL",
  vehicles: ["1990 Chevrolet Impala", "1995 Chevrolet Impala"],
};

export const apexPastDueBill: MockApexBill = {
  label: "Past Due Apex Bill",
  source: "apex",
  policyNumber: "en01",
  billStatus: "PAST_DUE",
  pastDueAmount: 1000,
  isAutoPay: false,
  paymentPlanPeriod: "SEMIANNUAL",
  vehicles: ["1999 Chevrolet Impala"],
};

export const mockApexBills: MockApexBill[] = [
  apexAutopayBill,
  apexAutopayFailedBill,
  apexPastDueBill,
  apexUpcomingBill,
];
